export function clearForm(methods) {
  const fields = Object.keys(methods.getValues());

  fields.forEach((field) => methods.resetField(field, ""));
}
